import { appClientConfig } from '@/app/utils/appClientConfig';
import { useAnalytics } from '@/app/utils/useAnalytics';
import cx from 'classnames';
import Link from 'next/link';

import { Button } from '@material-ui/core';

import styles from './EngagementButtons.module.scss';

export interface EngagementButtonsProps {
  trackAction: string;
  searchJobsUrl?: string;
  className?: string;
}

const EngagementButtons = ({
  className,
  trackAction,
  searchJobsUrl = '/jobs',
}: EngagementButtonsProps) => {
  const track = useAnalytics();
  const profileUrl = appClientConfig.practitionerProfileUrl ?? '';

  return (
    <div className={cx(styles.container, className)}>
      <Button
        variant="contained"
        className={cx(styles.button, styles.joinButton)}
        href={`${profileUrl}/sign-up`}
        onClick={() =>
          track('Click', {
            action: `${trackAction} - join us`,
            'element text': 'Join us',
            'element type': 'button',
          })
        }
      >
        Join us
      </Button>
      <Link href={searchJobsUrl} passHref legacyBehavior>
        <Button
          component="a"
          variant="outlined"
          className={cx(styles.button, styles.searchButton)}
          onClick={() =>
            track('Click', {
              action: `${trackAction} - search for jobs`,
              'element text': 'Search for jobs',
              'element type': 'button',
            })
          }
        >
          Search for jobs
        </Button>
      </Link>
    </div>
  );
};

export default EngagementButtons;
